import cn from 'classnames';
import { useState } from 'react';

import Button from 'components/common/Button';
import Heading from 'components/common/Heading';
import Text from 'components/common/Text';
import Link from 'components/icons/Link';
import { TEMPO } from 'lib/constants';
import styles from 'styles/components/signUpFunnel/thankYou/ShareInvitations';

const ShareInvitations = ({ brand, inviteDescription, invitationLink, shareSheetText }) => {
  const isTempo = brand === TEMPO;
  const [copy, setCopy] = useState('Copy Link');

  const shareInvitation = async () => {
    if (window.navigator.share) {
      try {
        await window.navigator.share({
          title: shareSheetText,
          url: invitationLink,
        });
      } catch {
        return;
      }
    }
  };

  const copyLink = () => {
    window.navigator.clipboard.writeText(invitationLink);
    setCopy('Copied!');
    setTimeout(() => {
      setCopy('Copy Link');
    }, 2000);
  };

  return (
    <>
      <div className={cn(styles.experimentShareInvitationsContainer, styles[brand])}>
        <Heading brandStylesOverrides="h3" className={styles.experimentHeader}>
          Refer. Earn. Repeat.
        </Heading>
        <Text brandStylesOverrides="textSm" className={styles.experimentText}>
          {inviteDescription}
        </Text>
        <Button
          type="button"
          variation="Pill"
          className="m-auto my-4 flex w-11/12 items-center justify-center text-base"
          onClick={shareInvitation}
        >
          Share Invite
        </Button>
        <div className="m-auto my-6 flex items-center justify-center" onClick={copyLink}>
          <Link fillColor={isTempo ? '#0558C3' : undefined} />
          <Text
            className={cn({ 'text-tempo-blue-90': isTempo, 'text-green-100': !isTempo }, 'mx-1')}
          >
            {copy}
          </Text>
        </div>
      </div>
    </>
  );
};

ShareInvitations.propTypes = {
  brand: PropTypes.string.isRequired,
  invitationLink: PropTypes.string.isRequired,
  inviteDescription: PropTypes.string.isRequired,
  shareSheetText: PropTypes.string.isRequired,
};

export default ShareInvitations;
